'use client';

import { useContext } from 'react';

import AppConfigContext from './AppConfigContext';

export default function useAppConfig() {
  const appConfig = useContext(AppConfigContext);

  return appConfig;
}
